export default __webpack_public_path__ + "static/media/Subtitle.8961970e.svg";